'use client';

import { FC } from 'react';
import IconTileBreakup from './IconTileBreakup';
import Link from './Link';

export interface PricingCustomerStoriesProps {
  hideComponent?: boolean;
  title: React.ReactNode;
  gridItems: {
    image: React.ReactNode;
    title: string;
    description: string;
    href: string;
  }[];
}

const PricingCustomerStories: FC<PricingCustomerStoriesProps> = ({
  hideComponent,
  title,
  gridItems = [],
}) => {
  const header = (
    <div className="flex flex-col gap-3 text-center">
      <h3 className="text-30/35 md:text-display3 font-500 tracking-tight">{title}</h3>
    </div>
  );

  const storiesGrid = (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-gutter-mobile md:gap-x-gutter-desktop gap-y-3">
      {gridItems.map((item) => (
        <div
          key={`pricing-customer-story-${item.href}`}
          className="h-full px-4 py-4 bg-white rounded-[12px] flex flex-col gap-6 justify-center items-center relative hover:bg-citron-100 transition-colors duration-200 ease-in-out-quad"
        >
          {item.image}
          <div className="flex flex-col gap-2 text-center items-center justify-center">
            <p className="text-84/84 font-500 tracking-tight">
              <Link href={item.href} className="link-cover">
                {item.title}
              </Link>
            </p>
            <p className="text-20/28">{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div className={`${hideComponent ? "hidden" : "flex"} bg-white-100 mt-8 md:mt-22 px-container-mobile md:px-container-desktop py-[120px]`}>
        <div className="mx-auto max-w-grid">
          <div className="flex flex-col gap-6">
            {header}
            {storiesGrid}
          </div>
        </div>
      </div>
      <div className={`${hideComponent ? "hidden" : "flex"} flex-wrap w-full`}>
        <div className="h-30 md:h-[134px] hidden md:flex relative w-full overflow-hidden bg-white-100">
          <IconTileBreakup data-fill-color="#FFF" className="absolute left-[-100vw] right-[-100vw] bottom-[-1px] w-[300vw] md:left-0 md:right-0 md:w-full h-auto" />
        </div>
        <div className="flex md:hidden relative w-full mt-[-34px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="360" height="35" viewBox="0 0 360 35" fill="none" className="w-full">
            <path fillRule="evenodd" clipRule="evenodd" d="M-222 0.302527H-87.8333L-87.8337 11.605H46.333V0.302444L-87.8333 0.302527V-11H-222V0.302527ZM582 0.302527H447.833V-11H582V0.302527ZM447.833 0.302527L447.833 11.605H313.667V0.302444L447.833 0.302527ZM180.5 22.9079H313.667V11.6054H180.5H179.5H46.3331V22.9079H179.5H180.5ZM582 40.921H447.833V35.0002H314V23.0002H447.833V14.4307H582V40.921ZM-87.8333 40.921H-222V14.4307H-87.8333V23.0002H45.9999V35.0002H-87.8333V40.921Z" fill="white" />
          </svg>
        </div>
      </div>
    </>
  );
};

export default PricingCustomerStories;
